import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import { Blog as BlogModel } from "@/models/blog";
import Blog from "@/components/blog/Blog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogPage',
  setup(__props) {

const store = useStore();
const route = useRoute();

const blog = computed<BlogModel>(() => store.state.blog);

onMounted(() => {
  store.dispatch(Actions.GetBlog, route.params.id);
});

return (_ctx: any,_cache: any) => {
  return (blog.value)
    ? (_openBlock(), _createBlock(Blog, {
        key: 0,
        blog: blog.value
      }, null, 8, ["blog"]))
    : _createCommentVNode("", true)
}
}

})